import { useMutation } from '@tanstack/react-query';

import { trafficSourceTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const removeTrafficSource: trafficSourceTypes.RemoveTrafficSourceData = ({ _id }) => {
  return axios.delete(`/traffic-sources/${_id}`);
};

type QueryFnType = typeof removeTrafficSource;

type UseRemoveTrafficSourceOptions = {
  config?: MutationConfig<(params: Parameters<QueryFnType>[0]) => ReturnType<QueryFnType>>;
};

export function useRemoveTrafficSource({ config = {} }: UseRemoveTrafficSourceOptions = {}) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['traffic-sources']);
    },
    ...config,
    mutationFn: removeTrafficSource,
  });
}
